import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { Button, Card, Icon } from "semantic-ui-react";

const HDRCard = observer(({ submitCallback }) => (
  <Card fluid>
    <Icon name="images outline" className="product-icon" />
    <Card.Content>
      <Card.Header>HDR</Card.Header>
      <Card.Meta>Get up to 50 HDR images for FREE!</Card.Meta>
      <Card.Description>
        Upload your exposure bracketed images and let us do the work to make the HDR fusion.
        <br />
        <br />
        Your first package includes up to 50 images that are FREE for your tour. Additional packages are 3 credits, with
        up to 50 images in each additional package.
      </Card.Description>
    </Card.Content>
    <Card.Content extra>
      <Button type="button" onClick={() => submitCallback()} primary className="button">
        HDR
      </Button>
    </Card.Content>
  </Card>
));

HDRCard.propTypes = {
  submitCallback: PropTypes.func.isRequired,
};

export default HDRCard;
